/**
 * Small helper for rendering tag pills from a debtor's tag_ids.
 *
 * `tags` is expected to be the array returned by GET /api/tags (with id/name/color).
 * `tagIds` is the debtor's tag_ids array.
 *
 * A hex → rgba() converter turns the stored solid hex into a 15%-opacity bg
 * that renders well on the dark navy panels.
 */
export const TAG_PALETTE = [
  "#4CA6FF", "#A67BE6", "#F5A25E", "#58D68D", "#E874A2",
  "#F5D658", "#5EE0D6", "#E67B7B", "#B8B8B8", "#7BCE58",
];

export const hexToRgba = (hex, alpha = 1) => {
  if (!hex) return `rgba(255,255,255,${alpha})`;
  const h = hex.replace("#", "");
  const bigint = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const tagPillStyle = (color, { border = false } = {}) => ({
  background: hexToRgba(color, 0.15),
  color,
  border: border ? `1px solid ${color}` : "none",
});

export const buildTagLookup = (tags = []) => {
  const map = new Map();
  tags.forEach((t) => map.set(t.id, t));
  return map;
};

export const resolveTags = (tagIds = [], lookup) => {
  if (!lookup) return [];
  return tagIds.map((id) => lookup.get(id)).filter(Boolean);
};
